module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scanner-container"
  }, [_c('lxm-loading', {
    attrs: {
      "visible": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "scanner",
    attrs: {
      "id": "qrCodeScanner"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.closeButtonVisible),
      expression: "closeButtonVisible"
    }],
    staticClass: "scanner-close",
    on: {
      "click": _vm.closeScanner
    }
  }, [_vm._v("✕")])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1d7dba34", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d7dba34!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Activity/QrCodeScanner.vue
// module id = 824
// module chunks = 0